module.exports = __webpack_public_path__ + "img/banner_text_01.6e3f9593.webp";